import { RelationshipForm } from './form';

export class RelationshipFormOutput {
  projectId?: string;

  constructor(form: RelationshipForm) {
    if (form.projectId) this.projectId = form.projectId;
  }
}
